import { ExternalLink } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LocationLinkProps {
  location: string
  href?: string | null
  className?: string
  /** When true, the label wraps to multiple lines instead of truncating. */
  wrap?: boolean
}

export function buildGoogleMapsHref(location: string, href?: string | null): string {
  const trimmedHref = href?.trim()
  if (trimmedHref) return trimmedHref
  const trimmedLocation = location.trim()
  if (!trimmedLocation) return ''
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(trimmedLocation)}`
}

export function LocationLink({ location, href, className, wrap = false }: LocationLinkProps) {
  const label = location.trim()
  if (!label) return null

  const mapsHref = buildGoogleMapsHref(label, href)
  const linkClass = cn(
    'text-brand-primary hover:text-brand-primary/80 hover:underline gap-1 min-w-0',
    wrap ? 'inline-flex items-start' : 'inline-flex items-center',
    className
  )

  return (
    <a
      href={mapsHref}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
      title={label}
    >
      <span className={wrap ? 'break-words' : 'truncate'}>{label}</span>
      <ExternalLink className={cn('h-3 w-3 shrink-0', wrap && 'mt-0.5')} />
    </a>
  )
}
